// Sammelt Dateien über mehrere Öffnungen des Datei-Dialogs hinweg, damit
// Dateien aus verschiedenen Ordnern nacheinander ausgewählt werden können.
// Der native Dialog würde die vorherige Auswahl sonst bei jedem Öffnen ersetzen.
//
// Verwendung: <input type="file" multiple class="js-accumulate-files" data-file-list="#selector-der-liste">
// Die Liste (ul) zeigt alle gesammelten Dateien mit Entfernen-Button.
const accumulatedFileStores = new WeakMap();

function getFileStore(input) {
    if (!accumulatedFileStores.has(input)) {
        accumulatedFileStores.set(input, new DataTransfer());
    }
    return accumulatedFileStores.get(input);
}

function renderAccumulatedFileList(input) {
    const list = $(input.getAttribute('data-file-list'));
    if (!list.length) {
        return;
    }

    const store = getFileStore(input);
    list.empty();

    Array.from(store.files).forEach(function (file, index) {
        const item = $('<li class="list-group-item p-2 d-flex justify-content-between align-items-center"></li>');
        item.append($('<span></span>').text(file.name));
        item.append(
            $('<button type="button" class="btn p-0" style="color:red"><em class="fa-solid fa-trash"></em></button>')
                .on('click', function () {
                    store.items.remove(index);
                    input.files = store.files;
                    renderAccumulatedFileList(input);
                })
        );
        list.append(item);
    });
}

$(document).on('change', 'input[type="file"].js-accumulate-files', function () {
    const store = getFileStore(this);

    Array.from(this.files).forEach(function (file) {
        const alreadyAdded = Array.from(store.files).some(function (existing) {
            return existing.name === file.name
                && existing.size === file.size
                && existing.lastModified === file.lastModified;
        });
        if (!alreadyAdded) {
            store.items.add(file);
        }
    });

    this.files = store.files;
    renderAccumulatedFileList(this);
});
